import { type FC, type HTMLAttributes } from "react";
import { useShopfrontDispatch } from "../../_Bootstrap/hooks";
import { showDialog } from "../../Actions/Dialogs/DialogActions";
import { ZendeskDialog } from "../Zendesk/ZendeskDialog";

interface Props extends HTMLAttributes<HTMLAnchorElement> {
    id: string;
    linkOnly?: boolean;
    scrollAnchor?: string;
}

export const ZendeskLink: FC<Props> = ({
    children,
    id,
    linkOnly,
    scrollAnchor,
    ...props
}) => {
    const dispatch = useShopfrontDispatch();

    return (
        <a
            {...props}
            href={
                `https://support.onshopfront.com/hc/en-us/articles/${id}` + (
                    typeof scrollAnchor === "string" ?
                        `#${scrollAnchor}` :
                        ""
                )
            }
            target="_blank"
            rel="noopener noreferrer"
            onClick={e => {
                if(linkOnly) {
                    return;
                }

                e.stopPropagation();
                e.preventDefault();

                dispatch(showDialog(
                    "Zendesk Help",
                    <ZendeskDialog
                        id={id}
                        scrollAnchor={scrollAnchor}
                    />,
                    "information",
                    false,
                    false,
                    true,
                    false
                ));
            }}
        >
            {children}
        </a>
    );
};
